var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJapaneseFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flags-4",
    clipPath: "url(#clip0_3427_18923)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0.25H2.5C1.5335 0.25 0.75 1.0335 0.75 2V10C0.75 10.9665 1.5335 11.75 2.5 11.75H10.5C11.4665 11.75 12.25 10.9665 12.25 10V2C12.25 1.0335 11.4665 0.25 10.5 0.25Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3427_18923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 0.25H2.5C1.5335 0.25 0.75 1.0335 0.75 2V10C0.75 10.9665 1.5335 11.75 2.5 11.75H10.5C11.4665 11.75 12.25 10.9665 12.25 10V2C12.25 1.0335 11.4665 0.25 10.5 0.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3427_18923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50014 9.5999C7.9203 9.5999 9.07157 7.98813 9.07157 5.9999C9.07157 4.01168 7.9203 2.3999 6.50014 2.3999C5.07998 2.3999 3.92871 4.01168 3.92871 5.9999C3.92871 7.98813 5.07998 9.5999 6.50014 9.5999Z",
    fill: "url(#paint0_linear_3427_18923)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3427_18923",
    x1: 3.92871,
    y1: 2.3999,
    x2: 3.92871,
    y2: 9.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB0831"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_18923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJapaneseFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JapaneseFlag.bf513cac20013be751d01178119dc1b9.svg";